import * as service from './UpdatePersonnel.service'
export default {
  data() {
    return {

      firstName: '',
      lastName: '',
      personnelDetails: [],
      medicalData: [],
      data: {
        isEdit: false,
        response: [],
        medicalData: []
      },
      currentRole: '',
      currentTab: 'Personal Information', //<<<<<<<<<<<REMOVE ???>>>>>>>>>>
      editShow: false, //WHY FALSE ??? MUST STAY FOR OTHER CODE TO WORK... BUT SEEMS ODD
      showInitialView: false, //FG - FOOF - added for "pages" that show a table first

      pageToDisplay: '',
      currentPage: '',
      thePageIds: []
    }
  },

  watch: {
    /* FG - FOOF - modified code so we now simply look for a change in the value of the variable
    --             pageToDisplay in order to highlight the chosen "tab" and display the
    --             associated page.
    */
    pageToDisplay: function () {
      this.changePage();
    }
  },

  mounted() {
    //Populate the array of personal profile pages that are available to display
    var pages = $(".hydroware-personal-profile-page");
    this.thePageIds=[];
    for(var i=0;i<pages.length;i++){
      this.thePageIds[i]=pages[i].id
    }

    //this.pageToDisplay="personalDashboardPage" <!--When dashboard is ready this will be the page to display-->
    //this.pageToDisplay="personalInformationPage" //FG - FOOF - First Release Security(7) - original line
    this.pageToDisplay=this.getInitialPage();//FG - FOOF - First Release Security(7) - new line 

    let context = this;
    let pid = this.$route.params.id ? this.$route.params.id : ''
    this.currentRole = authDetails.role

    this.$router.app.$on('updatedinfo', (data) => {
      //?????
    })
    if (this.displayBasicInfoTab) {
      alert("MOUNTED PID IS: " + pid)
      context.getPersonnelDetails(pid)
    }
    //NOTE: SECURITY SETTINGS SHOULD STOP MED INFO FROM DISPLAYING
    if (this.displayMedicalInfoTab) { //NOTE: NO DISPLAYING MED INFO FOR FIRST RELEASE - MEDICAL INFO - LOOK HERE     
      context.GetMedicalConditions(pid)
    }
    //
  },
  methods: {
    //FG - FOOF - After Cert - First Release Security (7) - below
    displayBasicInfoTab() {
      return this.$hydrowareSecurityJS.canDisplay_P('personnelbasicinfo')
    },
    displayJobInfoTab() {
      return this.$hydrowareSecurityJS.canDisplay_P('personneljobinfo')   
    },
    displayJobICETab() {
      return this.$hydrowareSecurityJS.canDisplay_P('personnelice');
    },
    //NOTE: SECURITY SETTINGS SHOULD STOP MED INFO FROM DISPLAYING
    displayMedicalInfoTab() {  //MEDICAL INFO - LOOK HERE
      //return false; //FG - FOOF - AFTER CERT - FIRST RELEASE - NO MED INFO
      return this.$hydrowareSecurityJS.canDisplay_P('personnelmedicalinfo');
    },
    displayCertificationsTab() {
      return this.$hydrowareSecurityJS.canDisplay_P('personnelcertifications');
    },
    displayPerformanceTab() {
      return this.$hydrowareSecurityJS.canDisplay_P('personnelperformance');
    },
    displayNoTabs() {
      return this.$hydrowareSecurityJS.canDisplay_P('personnelperformance');}
      ,
    //FG - FOOF - After Cert - First Release Security (7) - above
  
    getInitialPage() {
      if(this.displayBasicInfoTab()) return 'personalInformationPage'
      else if(this.displayJobInfoTab()) return 'personalJobDetailsPage'
      else if(this.displayJobICETab()) return 'personalICEPage'
      //NOTE: SECURITY SETTINGS SHOULD STOP MED INFO FROM DISPLAYING
      else if(this.displayMedicalInfoTab() ) return 'personalMedicalInfoPage' //FG - FOOF - AFTER CERT - FIRST RELEASE - MEDICAL INFO - LOOK HERE
      else if(this.displayCertificationsTab()) return 'personalCertificatesPage'
      else if(this.displayPerformanceTab()) return 'personalPerformancePage'
      else  return "personalNoTabs";
    },

    backProfile() {
      this.$router.push('/addpersonnel')

    },
    GetMedicalConditions(id) {
      let context = this
      loader.startLoader()
      service.GetMedicalConditions(id).then(function (response) {

        if (response && response != null) {
          context.data["medicalData"] = response

        } else {

          context.data["medicalData"] = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    //FG - FOOF - I DON'T THINK THE FUNCTION BELOW IS EVER USED
    cEdit() {alert("cEdit in UpdatePersonnel.controller.js")
      if (this.data["isEdit"] == true) {
        this.data["isEdit"] = false
      } else if (this.data["isEdit"] == false) {
        this.data["isEdit"] = true
      }
    },

    //FG - FOOF - Jun 5 2019 - the function below was in the original code that used el-tabs.... those tabs did
    //     not work well in a responsive environment so the code in the function changed a bit when I switched
    //     over to the "hydroware-neat-button"s.  
    //     ALSO it is now called from the "watch" function that is called when the pageToDisplay variable changes
    //     therefore I changed its name from "handleClick" to "changePage"
    //     MORE - there is code in the function that deals with security (who can do what).  That type of
    //     checking should be done in a security module but I've left it here because of time contraints.
    //handleClick(tab, event) { FROM OLD CODE
    changePage() {
      //this.currentTab = tab.label   FROM OLD CODE   
      //this.data["isEdit"] = true    FROM OLD CODE

      //NEW CODE BELOW - added when the tabs were replaced with the hydroware-neat-buttons
      //It simply highlights the chosen "tab" and displays the chosen page
      this.data["isEdit"]=false;
      this.editShow=false;
      this.showInitialView=false;
      //Hide the pages that are not chosen
      for(var i=0;i<this.thePageIds.length;i++) {
        if(this.thePageIds[i] != this.pageToDisplay) {
          $("#"+this.thePageIds[i]).css('display','none')
          var correspondingBtn = $("#"+this.thePageIds[i]+"_btn")
          if(correspondingBtn.hasClass('hydroware-neat-button_chosen')) {
            correspondingBtn.removeClass('hydroware-neat-button_chosen')
          }
        } 
      }
      //Show the page that is chosen and hi-lite the button
      $("#"+this.pageToDisplay).css('display','block')
      var correspondingBtn = $("#"+this.pageToDisplay+"_btn")
      if(!correspondingBtn.hasClass('hydroware-neat-button_chosen')) {
        correspondingBtn.addClass('hydroware-neat-button_chosen')
      }
      //NEW CODE - ABOVE

      if (this.pageToDisplay  == 'personalCertificatesPage') {
        //alert("HELLO")
        this.showInitialView = true;
        this.editShow = true;
      }
      
    },

    getPersonnelDetails(pid) {
      let context = this
      loader.startLoader()

      service.getPersonnelDetails(pid).then(function (response) {
        context.personnelDetails = response
        //FG - FOOF - Jun 2 2019 - only set is edit to true when the user clicks the edit button
        //     SO, i changed line below to set isEdit to false
        context.data = {
          response: response,
          email: authDetails.email,
          isEdit: false
        }
        loader.stopLoader()

      }, (error) => {
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
        loader.stopLoader()
      })


    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/UpdatePersonnel/UpdatePersonnel.controller.js